import httpService from "./httpService";

export default {
  findById(id) {
    return httpService.get(`/hcCaseMaster/${id}`);
  }
};



// WEBPACK FOOTER //
// ./src/services/hcCaseMasterService.js